import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  fetchUserList,
  fetchReportedUsers,
  updateUserRole,
  blockUser,
  fetchUserReports,
  assignStar,
  toggleSubscription,
} from "src/services/user.service";

interface FetchUserListPayload {
  page: number;
  limit: number;
  search?: string;
  role?: string;
}

interface UpdateUserRolePayload {
  uid: string;
  roleData: any;
}

export const doFetchUserList = createAsyncThunk(
  "user/fetchUserList",
  async (payload: FetchUserListPayload) => {
    try {
      const response: any = await fetchUserList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
        role: payload.role,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchReportedUsers = createAsyncThunk(
  "user/fetchReportedUsers",
  async (payload: FetchUserListPayload) => {
    try {
      const response: any = await fetchReportedUsers({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch reported users";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doFetchUserReports = createAsyncThunk(
  "user/fetchUserReports",
  async (uid: string) => {
    try {
      const response: any = await fetchUserReports(uid);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user reports";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doBlockUser = createAsyncThunk(
  "user/blockUser",
  async (uid: string) => {
    try {
      const response: any = await blockUser(uid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to block/unblock user";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doUpdateUserRole = createAsyncThunk(
  "user/updateUserRole",
  async (payload: UpdateUserRolePayload) => {
    try {
      const response: any = await updateUserRole(payload.uid, payload.roleData);
      toast.success(response.message || "User role updated successfully");
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to update user role";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doAssignStar = createAsyncThunk(
  "user/assignStar",
  async (uid: string) => {
    try {
      const response: any = await assignStar(uid);
      toast.success(
        response.message || "User star status updated successfully"
      );
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to update user star status";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);

export const doToggleSubscription = createAsyncThunk(
  "user/toggleSubscription",
  async (uid: string) => {
    try {
      const response: any = await toggleSubscription(uid);
      toast.success(response.message || "Subscription status updated");
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to toggle subscription";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
